import React, { useEffect, useState } from 'react';
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos'; // Import AOS library
function Page3() {
  const [experience, setExperience] = useState([
    {
      company: "ECS Fin",
      role: "Software Engineer",
      points: [
        "Developing and optimizing front-end applications for banking solutions using Next.js and React.js",
        "Implementing FSD architecture and SWR for efficient data fetching and state management",
        "Collaborating with backend developers working on Spring Boot to ensure seamless integration",
        "Enhancing UI/UX with Ant Design (AntD) for a modern and responsive user experience",
      ],
      skills: [
        "Next.js",
        "React.js",
        "FSD Architecture",
        "SWR",
        "Ant Design (AntD)",
        "Keycloack",
        "UI/UX Design",
      ]
    },    
    {
      company: 'Production & Maintenance Division IHRD',
      role: 'Front-end Lead - (React JS)',
      points: [
        'Led front-end development for the web streaming project, significantly improving user engagement and accessibility',
        'Developed responsive user interfaces using React.js',
        'Ensured seamless integration of front-end and back-end components through effective collaboration',
        'Kept the project updated with the latest technologies to maintain a cutting-edge user experience'
      ],
      skills:['React js','Tailwind css','Rest api','Figma','Ui / Ux design','Material ui','Javascript','Django','Postgre sql','Grafana',]
    },
    {
      company: 'Hashraf',
      role: 'Next.js Developer',
      points: [
        'Enhanced functionality and efficiency of a legal software project using Next.js',
        'Participated in agile development processes, including sprint planning and daily stand-ups',
        'Applied industry best practices to improve project outcomes',
      ],
      skills:['Next js','React js','Tailwind css','Javascript','Materail ui','Three js','React three fibre']

    }
  ]);
   // Initialize AOS when the component mounts
   useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Whether animation should happen only once while scrolling down
    });
  }, []);

  return (
    <div className="relative flex flex-col justify-center items-center md:h-lvh h-full md:py-0 pb-5 md:pt-12 pt-0 px-4  w-full bg-black" style={{ fontFamily: 'Ropa Sans, sans-serif' }}>
      <video
        autoPlay
        loop
        muted
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
        disablePictureInPicture
        // style={{ filter: 'blur(5px)', opacity: 0.7 }}
      >
        <source src="https://cdn.pixabay.com/video/2015/10/02/877-141149926_medium.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {/* <div className="h-full w-2 bg-gray-400 absolute left-5 md:flex hidden" data-aos="fade-down" data-aos-anchor-placement="top-center"></div>
      <div data-aos="fade-right" className="absolute left-3 border z-40 border-gray-400 md:flex hidden items-center gap-2 px-2 rounded-full bg-gray-900 text-gray-300 shadow-lg">
        <span className="w-2 h-2 bg-gray-400 rounded-full"></span>
        <span className="font-bold">Work Experience</span>
      </div> */}

      {/* heading for smaller screens */}
      {/* <div data-aos="fade-right" className=' underline py-1 rounded-full text-gray-300 font-bold absolute left-5 top-1 border-gray-400 flex-row items-center gap-2 md:hidden flex'>
        <span className='w-3 h-3 bg-gray-400'></span>
        <span className='text-xl'>Work Experience</span>
      </div> */}

{/* <div style={{ position: 'absolute', left: '100px', top: '7px' }}>
        <h1 className='pb-5 font-bold text-xl text-gray-200' style={{ fontFamily: 'Chakra Petch' }}>Work Experiences</h1>
      </div> */}

      <div data-aos="zoom-in-up" className="flex flex-col w-full md:w-10/12 mx-auto space-y-5">
      <h1 className='pb-5 font-bold text-xl text-gray-200' style={{ fontFamily: 'Chakra Petch' }}>Work Experiences</h1>

        {experience.map((item, index) => (
          <div className='flex flex-row gap-1 w-full h-full'>
            {/* <div className='text-white '>0{index+1}</div> */}
            <div
            key={index}
            className={`relative flex flex-col md:flex-row justify-between w-full p-5 border-s-4 bg-black border ${index==0?'border-[#731cd7]':'border-gray-400'} rounded-lg hover:z-50 hover:scale-105 transition-transform duration-300 shadow-[0_8px_16px_rgba(192,192,192,0.4)]`}
          >
            <div className="w-full md:w-7/12">
              <div className="flex items-center gap-4">
                <span className="text-2xl font-bold text-white">{item.company}</span>
                <span className="text-white text-sm bg-gray-800 px-3 py-1 rounded-md">
                  {item.role}
                </span>
              </div>
              <ul className="mt-3 text-gray-400 list-disc list-inside">
                {item.points.map((point, idx) => (
                  <li key={idx} className="text-sm mb-1">
                    {point}
                  </li>
                ))}
              </ul>
            </div>

            <div className="w-full md:w-4/12 mt-5 md:mt-0 bg-gray-950 p-4 rounded-lg border border-gray-500">
              <div className="text-center text-white font-bold mb-3">Technology used</div>
              <div className="flex flex-wrap gap-2 justify-center">
                {item?.skills?.map((item)=>(
                <span className="px-3 py-1 bg-gray-900 text-gray-300 rounded-full text-sm hover:bg-gray-400 hover:text-black transition-colors cursor-pointer">
                 {item}
                </span>
                ))}
                {/* <span className="px-3 py-1 bg-gray-900 text-gray-300 rounded-full text-sm hover:bg-gray-400 hover:text-black transition-colors cursor-pointer">
                  Next.js
                </span>
                <span className="px-3 py-1 bg-gray-900 text-gray-300 rounded-full text-sm hover:bg-gray-400 hover:text-black transition-colors cursor-pointer">
                  Tailwind CSS
                </span>
                <span className="px-3 py-1 bg-gray-900 text-gray-300 rounded-full text-sm hover:bg-gray-400 hover:text-black transition-colors cursor-pointer">
                  Node.js
                </span>
                <span className="px-3 py-1 bg-gray-900 text-gray-300 rounded-full text-sm hover:bg-gray-400 hover:text-black transition-colors cursor-pointer">
                  FastAPI
                </span> */}
              </div>
            </div>
          </div>
            </div>
        ))}
      </div>
    </div>
  );
}

export default Page3;
